// app/utils/error-reporter.ts
//
// Browser-only helper to send an error report to /_actions/log-client-error.
// Uses sendBeacon if available (works on tab close), otherwise fetch+keepalive.
// Safe to call from the ErrorBoundary; safe to no-op on the server.

const ENDPOINT = "/_actions/log-client-error";

type ReportInput = {
    kind: "error" | "unhandledrejection" | "errorboundary";
    message: string;
    stack?: string;
    componentStack?: string;
    extra?: Record<string, unknown>;
};

export function reportError(input: ReportInput) {
    if (typeof window === "undefined") return;

    const payload = JSON.stringify({
        kind: input.kind,
        message: input.message ?? "",
        stack: input.stack ?? "",
        componentStack: input.componentStack ?? "",
        extra: input.extra ?? null,
        url: window.location.href,
        ua: navigator.userAgent,
        ts: Date.now(),
    });

    try {
        if (navigator.sendBeacon) {
            const blob = new Blob([payload], { type: "application/json" });
            const ok = navigator.sendBeacon(ENDPOINT, blob);
            if (ok) return;
        }
    } catch {
        // Fall through to fetch.
    }

    try {
        void fetch(ENDPOINT, {
            method: "POST",
            body: payload,
            headers: { "Content-Type": "application/json" },
            keepalive: true,
            credentials: "same-origin",
        });
    } catch {
        // Last resort: nothing we can do.
    }
}
